import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';

import * as Services from '@shared/core/services';
import * as Models from '@shared/core/models';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ILocationBusinessModel } from '@shared/state';

@Component({
    selector: 'shared-locations-hero-header',
    templateUrl: './locations-hero-header.shared.component.html',
    styleUrls: ['./locations-hero-header.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsHeroHeaderComponent implements OnInit, OnChanges {
    public btnSize: OLO.Components.BUTTON_SIZE = 'lg';
    @Input() public locationNo: number;

    public location$: Observable<ILocationBusinessModel>;
    public openStatus$: Observable<OLO.Common.ILocationOpenStatus>;
    public collectionTypesLinks$: Observable<Models.CollectionTypeItem[]>;
    public isDineInActive$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
        public changeDetectorRef: ChangeDetectorRef,
        public routeService: Services.RouteService,
        public modalsService: Services.ModalsService,
    ) { }

    ngOnInit(): void {
        this._setLocation();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.locationNo && changes.locationNo.previousValue !== this.locationNo) {
            this._setLocation();
        }
    }

    @HostListener('window:resize', ['$event']) public onWindowResizeHandler($event: Event): void {
        this.changeDetectorRef.markForCheck();
    }

    private _setLocation(): void {
        this.location$ = this.controllers.locations.locationDetails$(this.locationNo);
        this.openStatus$ = this.controllers.locations.openStatus(this.locationNo, true);
        this.collectionTypesLinks$ = this.controllers.collectionType.collectionTypesLinksForLocation$(this.locationNo);
        this.isDineInActive$ = this.controllers.collectionType.isDineInActive$();

        this.controllers.images.requestHeroLocationImage(this.locationNo);

        setTimeout(() => {
            this.changeDetectorRef.detectChanges();
        }, 0);
    }

    public onBackClick($event: Event): Promise<boolean> {
        return this.controllers.routes.navigateToLocationsSearchView();
    }

    public handleMoreInformationClick($event: Event): void {
        this.modalsService.show({ type: 'location-open-hours', locationNo: this.locationNo, params: { canNavigate: false } });
    }

    public handleLocationAddressClick($event: Event): void {
        this.controllers.locations.googleMapsLocationAddressLink$(this.locationNo)
            .pipe(
                take(1),
            )
            .subscribe(link => {
                if (link) {
                    window.open(link, '_blank').focus();
                }
            });
    }

    public get centerHeaders(): boolean {
        return window.innerWidth < 768;
    }
}
